import React,{useState} from 'react'
import {getAllUrlParams,setLocalStorage,getLocalStorage} from "../../utils/utils"
import settings from '../../settings.json'

import axios from 'axios'

export default function Registration() {
    const [username, setUsername] = useState("")
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")

    function registration(event){
        event.preventDefault()
        setLoading(true);

        let data={
            "username":username,
            "password":password,
            "first_name":firstName,
            "last_name":lastName
        }
        axios.post(settings.url_api+"/auth/register/",data).then((res)=>{
            try {
                setMessage("Controlla la tua email e conferma l'accesso")
            } catch (error) {
            }
            window.location.href="/shop";
        }).catch((error)=>{
            setLoading(false)
        })
    }

    return(
    <div className="simple-login-container">
        <h2>Registration</h2>
        <form onSubmit={(e)=>registration(e)}>
        <div className="row">
            <div className="col-md-12 form-group">
                <input type="text" className="form-control" placeholder="Name" onChange={(e)=>setFirstName(e.target.value)} value={firstName}/>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 form-group">
                <input type="text" className="form-control" placeholder="Lastname" onChange={(e)=>setLastName(e.target.value)} value={lastName}/>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 form-group">
                <input type="email" className="form-control" placeholder="Email" onChange={(e)=>setUsername(e.target.value)} value={username}/>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 form-group">
                <input type="password" placeholder="Enter your Password" onChange={(e)=>setPassword(e.target.value)} value={password} className="form-control"/>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 form-group">
                <input disabled={loading} type="submit" className="btn btn-block btn-login" value="Register" />
            </div>
        </div>
        <div style={{border:"1px solid grey"}}>
            {message}
        </div>
        </form>
    </div>
    )
}